import type { ReactNode } from 'react';

/** Labelled form control with a hint or its validation message. */
export function Field({
  label,
  error,
  hint,
  children,
}: {
  label: string;
  error?: string;
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <label className={error ? 'field has-error' : 'field'}>
      {label}
      {children}
      {hint && !error && <small>{hint}</small>}
      {error && <span className="field-error">{error}</span>}
    </label>
  );
}
